
import AchatFerraille from "@/pages/nos-services/achat-metaux/AchatFerraille";
import AchatCuivre from "@/pages/nos-services/achat-metaux/AchatCuivre";
import AchatAluminium from "@/pages/nos-services/achat-metaux/AchatAluminium";
import AchatPlomb from "@/pages/nos-services/achat-metaux/AchatPlomb";
import AchatZinc from "@/pages/nos-services/achat-metaux/AchatZinc";
import AchatLaiton from "@/pages/nos-services/achat-metaux/AchatLaiton";
import AchatInox from "@/pages/nos-services/achat-metaux/AchatInox";
import AchatBatteries from "@/pages/nos-services/achat-metaux/AchatBatteries";
import AchatMetauxAveyron from "@/pages/nos-services/achat-metaux/AchatMetauxAveyron";
import AchatMetauxHauteGaronne from "@/pages/nos-services/achat-metaux/AchatMetauxHauteGaronne";
import AchatMetauxTarn from "@/pages/nos-services/achat-metaux/AchatMetauxTarn";
import AchatMetauxLot from "@/pages/nos-services/achat-metaux/AchatMetauxLot";
import AchatMetauxCantal from "@/pages/nos-services/achat-metaux/AchatMetauxCantal";
import AchatMetauxLozere from "@/pages/nos-services/achat-metaux/AchatMetauxLozere";
import AchatMetauxHerault from "@/pages/nos-services/achat-metaux/AchatMetauxHerault";
import AchatMetauxTarnEtGaronne from "@/pages/nos-services/achat-metaux/AchatMetauxTarnEtGaronne";
import AchatMetauxValDOise from "@/pages/nos-services/achat-metaux/AchatMetauxValDOise";

// Metal type routes
export const metalTypeRoutes = [
  { path: "/nos-services/achat-metaux/ferraille", element: AchatFerraille },
  { path: "/nos-services/achat-metaux/cuivre", element: AchatCuivre },
  { path: "/nos-services/achat-metaux/aluminium", element: AchatAluminium },
  { path: "/nos-services/achat-metaux/plomb", element: AchatPlomb },
  { path: "/nos-services/achat-metaux/zinc", element: AchatZinc },
  { path: "/nos-services/achat-metaux/laiton", element: AchatLaiton },
  { path: "/nos-services/achat-metaux/inox", element: AchatInox },
  { path: "/nos-services/achat-metaux/batteries", element: AchatBatteries },
];

// Geographic metal routes
export const metalGeographicRoutes = [
  { path: "/nos-services/achat-metaux/aveyron", element: AchatMetauxAveyron },
  { path: "/nos-services/achat-metaux/haute-garonne", element: AchatMetauxHauteGaronne },
  { path: "/nos-services/achat-metaux/tarn", element: AchatMetauxTarn },
  { path: "/nos-services/achat-metaux/lot", element: AchatMetauxLot },
  { path: "/nos-services/achat-metaux/cantal", element: AchatMetauxCantal },
  { path: "/nos-services/achat-metaux/lozere", element: AchatMetauxLozere },
  { path: "/nos-services/achat-metaux/herault", element: AchatMetauxHerault },
  { path: "/nos-services/achat-metaux/tarn-et-garonne", element: AchatMetauxTarnEtGaronne },
  { path: "/nos-services/achat-metaux/val-doise", element: AchatMetauxValDOise },
];

// Additional SEO routes for department codes
export const metalDepartmentRoutes = [
  { path: "/nos-services/achat-metaux/12", element: AchatMetauxAveyron },
  { path: "/nos-services/achat-metaux/31", element: AchatMetauxHauteGaronne },
  { path: "/nos-services/achat-metaux/81", element: AchatMetauxTarn },
  { path: "/nos-services/achat-metaux/46", element: AchatMetauxLot },
  { path: "/nos-services/achat-metaux/15", element: AchatMetauxCantal },
  { path: "/nos-services/achat-metaux/48", element: AchatMetauxLozere },
  { path: "/nos-services/achat-metaux/34", element: AchatMetauxHerault },
  { path: "/nos-services/achat-metaux/82", element: AchatMetauxTarnEtGaronne },
  { path: "/nos-services/achat-metaux/95", element: AchatMetauxValDOise },
];
